var map = {
	"./square/ac.svg": 1770,
	"./square/ad.svg": 1771,
	"./square/ae.svg": 1772,
	"./square/af.svg": 1773,
	"./square/ag.svg": 1774,
	"./square/ai.svg": 1775,
	"./square/al.svg": 1776,
	"./square/am.svg": 1777,
	"./square/ao.svg": 1778,
	"./square/aq.svg": 1779,
	"./square/ar.svg": 1780,
	"./square/as.svg": 1781,
	"./square/at.svg": 1782,
	"./square/au.svg": 1783,
	"./square/aw.svg": 1784,
	"./square/ax.svg": 1785,
	"./square/az.svg": 1786,
	"./square/ba.svg": 1787,
	"./square/bb.svg": 1788,
	"./square/bd.svg": 1789,
	"./square/be.svg": 1790,
	"./square/bf.svg": 1791,
	"./square/bg.svg": 1792,
	"./square/bh.svg": 1793,
	"./square/bi.svg": 1794,
	"./square/bj.svg": 1795,
	"./square/bl.svg": 1796,
	"./square/bm.svg": 1797,
	"./square/bn.svg": 1798,
	"./square/bo.svg": 1799,
	"./square/bq.svg": 1800,
	"./square/br.svg": 1801,
	"./square/bs.svg": 1802,
	"./square/bt.svg": 1803,
	"./square/bv.svg": 1804,
	"./square/bw.svg": 1805,
	"./square/by.svg": 1806,
	"./square/bz.svg": 1807,
	"./square/ca.svg": 1808,
	"./square/cc.svg": 1809,
	"./square/cd.svg": 1810,
	"./square/cefta.svg": 1811,
	"./square/cf.svg": 1812,
	"./square/cg.svg": 1813,
	"./square/ch.svg": 1814,
	"./square/ci.svg": 1815,
	"./square/ck.svg": 1816,
	"./square/cl.svg": 1817,
	"./square/cm.svg": 1818,
	"./square/cn.svg": 1819,
	"./square/co.svg": 1820,
	"./square/cp.svg": 1821,
	"./square/cr.svg": 1822,
	"./square/cu.svg": 1823,
	"./square/cv.svg": 1824,
	"./square/cw.svg": 1825,
	"./square/cx.svg": 1826,
	"./square/cy.svg": 1827,
	"./square/cz.svg": 1828,
	"./square/de.svg": 1829,
	"./square/dg.svg": 1830,
	"./square/dj.svg": 1831,
	"./square/dk.svg": 1832,
	"./square/dm.svg": 1833,
	"./square/do.svg": 1834,
	"./square/dz.svg": 1835,
	"./square/ea.svg": 1836,
	"./square/ec.svg": 1837,
	"./square/ee.svg": 1838,
	"./square/eg.svg": 1839,
	"./square/eh.svg": 1840,
	"./square/er.svg": 1841,
	"./square/es-ct.svg": 1842,
	"./square/es-ga.svg": 1843,
	"./square/es.svg": 1844,
	"./square/et.svg": 1845,
	"./square/eu.svg": 1846,
	"./square/fi.svg": 1847,
	"./square/fj.svg": 1848,
	"./square/fk.svg": 1849,
	"./square/fm.svg": 1850,
	"./square/fo.svg": 1851,
	"./square/fr.svg": 1852,
	"./square/ga.svg": 1853,
	"./square/gb-eng.svg": 1854,
	"./square/gb-nir.svg": 1855,
	"./square/gb-sct.svg": 1856,
	"./square/gb-wls.svg": 1857,
	"./square/gb.svg": 1858,
	"./square/gd.svg": 1859,
	"./square/ge.svg": 1860,
	"./square/gf.svg": 1861,
	"./square/gg.svg": 1862,
	"./square/gh.svg": 1863,
	"./square/gi.svg": 1864,
	"./square/gl.svg": 1865,
	"./square/gm.svg": 1866,
	"./square/gn.svg": 1867,
	"./square/gp.svg": 1868,
	"./square/gq.svg": 1869,
	"./square/gr.svg": 1870,
	"./square/gs.svg": 1871,
	"./square/gt.svg": 1872,
	"./square/gu.svg": 1873,
	"./square/gw.svg": 1874,
	"./square/gy.svg": 1875,
	"./square/hk.svg": 1876,
	"./square/hm.svg": 1877,
	"./square/hn.svg": 1878,
	"./square/hr.svg": 1879,
	"./square/ht.svg": 1880,
	"./square/hu.svg": 1881,
	"./square/ic.svg": 1882,
	"./square/id.svg": 1883,
	"./square/ie.svg": 1884,
	"./square/il.svg": 1885,
	"./square/im.svg": 1886,
	"./square/in.svg": 1887,
	"./square/io.svg": 1888,
	"./square/iq.svg": 1889,
	"./square/ir.svg": 1890,
	"./square/is.svg": 1891,
	"./square/it.svg": 1892,
	"./square/je.svg": 1893,
	"./square/jm.svg": 1894,
	"./square/jo.svg": 1895,
	"./square/jp.svg": 1896,
	"./square/ke.svg": 1897,
	"./square/kg.svg": 1898,
	"./square/kh.svg": 1899,
	"./square/ki.svg": 1900,
	"./square/km.svg": 1901,
	"./square/kn.svg": 1902,
	"./square/kp.svg": 1903,
	"./square/kr.svg": 1904,
	"./square/kw.svg": 1905,
	"./square/ky.svg": 1906,
	"./square/kz.svg": 1907,
	"./square/la.svg": 1908,
	"./square/lb.svg": 1909,
	"./square/lc.svg": 1910,
	"./square/li.svg": 1911,
	"./square/lk.svg": 1912,
	"./square/lr.svg": 1913,
	"./square/ls.svg": 1914,
	"./square/lt.svg": 1915,
	"./square/lu.svg": 1916,
	"./square/lv.svg": 1917,
	"./square/ly.svg": 1918,
	"./square/ma.svg": 1919,
	"./square/mc.svg": 1920,
	"./square/md.svg": 1921,
	"./square/me.svg": 1922,
	"./square/mf.svg": 1923,
	"./square/mg.svg": 1924,
	"./square/mh.svg": 1925,
	"./square/mk.svg": 1926,
	"./square/ml.svg": 1927,
	"./square/mm.svg": 1928,
	"./square/mn.svg": 1929,
	"./square/mo.svg": 1930,
	"./square/mp.svg": 1931,
	"./square/mq.svg": 1932,
	"./square/mr.svg": 1933,
	"./square/ms.svg": 1934,
	"./square/mt.svg": 1935,
	"./square/mu.svg": 1936,
	"./square/mv.svg": 1937,
	"./square/mw.svg": 1938,
	"./square/mx.svg": 1939,
	"./square/my.svg": 1940,
	"./square/mz.svg": 1941,
	"./square/na.svg": 1942,
	"./square/nc.svg": 1943,
	"./square/ne.svg": 1944,
	"./square/nf.svg": 1945,
	"./square/ng.svg": 1946,
	"./square/ni.svg": 1947,
	"./square/nl.svg": 1948,
	"./square/no.svg": 1949,
	"./square/np.svg": 1950,
	"./square/nr.svg": 1951,
	"./square/nu.svg": 1952,
	"./square/nz.svg": 1953,
	"./square/om.svg": 1954,
	"./square/pa.svg": 1955,
	"./square/pe.svg": 1956,
	"./square/pf.svg": 1957,
	"./square/pg.svg": 1958,
	"./square/ph.svg": 1959,
	"./square/pk.svg": 1960,
	"./square/pl.svg": 1961,
	"./square/pm.svg": 1962,
	"./square/pn.svg": 1963,
	"./square/pr.svg": 1964,
	"./square/ps.svg": 1965,
	"./square/pt.svg": 1966,
	"./square/pw.svg": 1967,
	"./square/py.svg": 1968,
	"./square/qa.svg": 1969,
	"./square/re.svg": 1970,
	"./square/ro.svg": 1971,
	"./square/rs.svg": 1972,
	"./square/ru.svg": 1973,
	"./square/rw.svg": 1974,
	"./square/sa.svg": 1975,
	"./square/sb.svg": 1976,
	"./square/sc.svg": 1977,
	"./square/sd.svg": 1978,
	"./square/se.svg": 1979,
	"./square/sg.svg": 1980,
	"./square/sh.svg": 1981,
	"./square/si.svg": 1982,
	"./square/sj.svg": 1983,
	"./square/sk.svg": 1984,
	"./square/sl.svg": 1985,
	"./square/sm.svg": 1986,
	"./square/sn.svg": 1987,
	"./square/so.svg": 1988,
	"./square/sr.svg": 1989,
	"./square/ss.svg": 1990,
	"./square/st.svg": 1991,
	"./square/sv.svg": 1992,
	"./square/sx.svg": 1993,
	"./square/sy.svg": 1994,
	"./square/sz.svg": 1995,
	"./square/ta.svg": 1996,
	"./square/tc.svg": 1997,
	"./square/td.svg": 1998,
	"./square/tf.svg": 1999,
	"./square/tg.svg": 2000,
	"./square/th.svg": 2001,
	"./square/tj.svg": 2002,
	"./square/tk.svg": 2003,
	"./square/tl.svg": 2004,
	"./square/tm.svg": 2005,
	"./square/tn.svg": 2006,
	"./square/to.svg": 2007,
	"./square/tr.svg": 2008,
	"./square/tt.svg": 2009,
	"./square/tv.svg": 2010,
	"./square/tw.svg": 2011,
	"./square/tz.svg": 2012,
	"./square/ua.svg": 2013,
	"./square/ug.svg": 2014,
	"./square/um.svg": 2015,
	"./square/un.svg": 2016,
	"./square/us.svg": 2017,
	"./square/uy.svg": 2018,
	"./square/uz.svg": 2019,
	"./square/va.svg": 2020,
	"./square/vc.svg": 2021,
	"./square/ve.svg": 2022,
	"./square/vg.svg": 2023,
	"./square/vi.svg": 2024,
	"./square/vn.svg": 2025,
	"./square/vu.svg": 2026,
	"./square/wf.svg": 2027,
	"./square/ws.svg": 2028,
	"./square/xk.svg": 2029,
	"./square/xx.svg": 2030,
	"./square/ye.svg": 2031,
	"./square/yt.svg": 2032,
	"./square/za.svg": 2033,
	"./square/zm.svg": 2034,
	"./square/zw.svg": 2035
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1769;